<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12 xs12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Tỷ giá - phí</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg6 md6 sm12 xs12>
                                    <h-currency-input v-model="configuration.Currency" :decimal="0" label="Tỷ giá" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg6 md6 sm12 xs12>
                                    <h-currency-input v-model="configuration.ExchangeRevenue" :decimal="0" label="Lãi tỷ giá" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input v-model="configuration.MinFeeBuy" :decimal="0" label="Phí mua tối thiểu" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input v-model="configuration.MinFeeWeight" :decimal="0" label="Phí vận chuyển tối thiểu" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input v-model="configuration.MinInvertFeeWeight" :decimal="0" label="Phí vận chuyển tối thiểu (đơn ngược)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <v-text-field type="number" v-model="configuration.OrderCompleteDate" label="Số ngày tự động hoàn thành đơn" class="input-group--focused"></v-text-field>
                                </v-flex>
                                </v-layout>
                            <v-layout row wrap>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input :decimal="0" v-model="configuration.Density" label="Tỷ trọng cân nặng" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input :decimal="0" v-model="configuration.InvertDensity" label="Tỷ trọng cân nặng (xuất khẩu)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input :decimal="2" v-model="configuration.MinVolume" label="Số khối tối thiểu" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input :decimal="1" v-model="configuration.BigpackageWeightLimit" label="Dung sai cân nặng bao hàng (kg)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg3 md3 sm12 xs12>
                                    <h-currency-input :decimal="2" v-model="configuration.BigpackageVolumeLimit" label="Dung sai kích thước bao hàng (m3)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <a target="blank" href="https://jsonformatter.org/">Link validate json</a>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-icon medium class="mr-2" color="gray darken-3" @click="excel_delta_dialog = true">fa-external-link-alt</v-icon>
                                    <v-textarea rows="5" v-model="configuration.CheckDeltas" label="Dung sai đối soát" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-icon medium class="mr-2" color="gray darken-3" @click="excel_editor_dialog = true">fa-external-link-alt</v-icon>
                                    <v-textarea rows="5" v-model="configuration.AuthAccounts" label="Danh sách tài khoản thanh toán" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.PackageState" label="Tình trạng xuất kho" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.FinanceTypes" label="Phân loại lệnh (Tài chính)" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.Departments" label="Phòng ban (Tài chính)" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.ProductTypes" label="Loại hàng" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.OtherFeeObj" label="Cấu hình phí khác của đơn hàng" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.ShippingTypes" label="Hình thức ship" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Tỷ lệ hoa hồng nhân viên</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input :decimal="1" v-model="configuration.FeeBuyRateForSale" label="CK phí dịch vụ cho sale (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input :decimal="1" v-model="configuration.RevenueRateForSale" label="CK tiền mặc cả cho sale (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input :decimal="1" v-model="configuration.FeeBuyRateForBuyer" label="CK phí dịch vụ cho mua (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input :decimal="1" v-model="configuration.RevenueRateForBuyer" label="CK tiền mặc cả cho mua (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <!-- <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.FeeWeightCommissionRates" label="Chiết khấu phí vận chuyển" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout> -->
                        </v-card-text>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Cấu hình liên hệ</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.ContactWorkFields" label="Danh sách lĩnh vực" class="input-group--focused"></v-textarea>
                                </v-flex>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.ContactSources" label="Danh sách nguồn liên hệ" class="input-group--focused"></v-textarea>
                                </v-flex>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.ContactStatus" label="Danh sách trạng thái liên hệ" class="input-group--focused"></v-textarea>
                                </v-flex>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.ContactKind" label="Quy mô liên hệ" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Thông báo khách hàng</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <vue-editor v-model="configuration.NoteForCustomer" label="Thông báo khách hàng" class="input-group--focused"></vue-editor>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Cấu hình SMS</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg12 md12 sm12 xs12>
                                    <v-textarea rows="5" v-model="configuration.SmsSwitch" label="Tắt/mở gửi sms" class="input-group--focused"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                    <v-layout row wrap>
                        <v-toolbar flat color="teal darken-2" dark>
                            <v-toolbar-title>Cài đặt Xadal (Chung)</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <div class="caption grey--text mb-3">Tài khoản Xadal dùng chung cho hệ thống (client-api). Mỗi nhân viên có thể cài đặt tài khoản riêng trong trang quản lý nhân viên.</div>
                            <v-layout row wrap>
                                <v-flex lg6 md6 sm12 xs12>
                                    <v-text-field
                                        v-model="configuration.XadalEmail"
                                        label="Email Xadal (Chung)"
                                        placeholder="email@xadal.com"
                                        prepend-icon="mdi-account"
                                        class="input-group--focused"
                                        clearable
                                    ></v-text-field>
                                </v-flex>
                                <v-flex lg6 md6 sm12 xs12>
                                    <v-text-field
                                        v-model="configuration.XadalPassword"
                                        label="Mật khẩu Xadal (Chung)"
                                        :type="showXadalPassword ? 'text' : 'password'"
                                        prepend-icon="mdi-lock"
                                        :append-icon="showXadalPassword ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append="showXadalPassword = !showXadalPassword"
                                        class="input-group--focused"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
    <oee-excel-editor v-model="configuration.AuthAccounts" title="Danh sách tài khoản TT" editor_width="800px" :columns="authColumns" :dialog="excel_editor_dialog" @closePopup="excel_editor_dialog = false" @change="configuration.AuthAccounts = $event"></oee-excel-editor>
    <oee-excel-editor v-model="configuration.CheckDeltas" title="Dung sai đối soát" editor_width="600px" :columns="deltaColumns" :dialog="excel_delta_dialog" @closePopup="excel_delta_dialog = false" @change="configuration.CheckDeltas = $event"></oee-excel-editor>
</div>
</template>

<script>
import { mapState } from "vuex";
import excel_editor from "@/components/popups/excel_editor"
import { VueEditor } from "vue2-editor";
import { isValidJson, sendErrorNotice } from '@/commons/utils';
export default {
    components: {
        'oee-excel-editor': excel_editor,
        VueEditor
    },
    data() {
        return {
            excel_editor_dialog: false,
            excel_delta_dialog: false,
            showXadalPassword: false,
            authColumns: [
                {
                    'name': 'name',
                    'width': '240px',
                    'label': 'Tên TK',
                    'key_field': false,
                    'type': 'string'
                },
                {
                    'name': 'value',
                    'width': '80px',
                    'label': 'ID',
                    'key_field': true,
                    'type': 'number'
                },
                {
                    'name': 'active',
                    'width': '100px',
                    'label': 'Trạng thái',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'wallet',
                    'width': '160px',
                    'label': 'Hạn mức',
                    'key_field': false,
                    'type': 'number'
                },
                {
                    'name': 'default',
                    'width': '160px',
                    'label': 'Hạn mức default',
                    'key_field': false,
                    'type': 'number'
                }
            ],
            deltaColumns: [
                {
                    'name': 'type',
                    'width': '220px',
                    'label': 'Cách tính',
                    'key_field': false,
                    'type': 'string'
                },
                {
                    'name': 'min',
                    'width': '100px',
                    'label': 'Min',
                    'key_field': true,
                    'type': 'number'
                },
                {
                    'name': 'max',
                    'width': '100px',
                    'label': 'Max',
                    'key_field': true,
                    'type': 'number'
                },
                {
                    'name': 'delta',
                    'width': '100px',
                    'label': 'Dung sai',
                    'key_field': false,
                    'type': 'number'
                }
            ]
        }
    },
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            if(this.configuration.AuthAccounts && !isValidJson(this.configuration.AuthAccounts)) {
                sendErrorNotice('Danh sách tài khoản thanh toán lỗi định dạng JSON');
                return;
            }
            if(this.configuration.PackageState && !isValidJson(this.configuration.PackageState)) {
                sendErrorNotice('Tình trạng xuất kho lỗi định dạng JSON');
                return;
            }
            if(this.configuration.FinanceTypes && !isValidJson(this.configuration.FinanceTypes)) {
                sendErrorNotice('Phân loại lệnh lỗi định dạng JSON');
                return;
            }
            if(this.configuration.Departments && !isValidJson(this.configuration.Departments)) {
                sendErrorNotice('Phòng ban lỗi định dạng JSON');
                return;
            }
            if(this.configuration.ProductTypes && !isValidJson(this.configuration.ProductTypes)) {
                sendErrorNotice('Loại hàng lỗi định dạng JSON');
                return;
            }
            if(this.configuration.ContactWorkFields && !isValidJson(this.configuration.ContactWorkFields)) {
                sendErrorNotice('Danh sách lĩnh vực lỗi định dạng JSON');
                return;
            }
            if(this.configuration.ContactSources && !isValidJson(this.configuration.ContactSources)) {
                sendErrorNotice('Danh sách nguồn liên hệ lỗi định dạng JSON');
                return;
            }
            if(this.configuration.ContactStatus && !isValidJson(this.configuration.ContactStatus)) {
                sendErrorNotice('Danh sách trạng thái liên hệ lỗi định dạng JSON');
                return;
            }
            if(this.configuration.ContactKind && !isValidJson(this.configuration.ContactKind)) {
                sendErrorNotice('Quy mô liên hệ lỗi định dạng JSON');
                return;
            }
            if(this.configuration.SmsSwitch && !isValidJson(this.configuration.SmsSwitch)) {
                sendErrorNotice('Cấu hình SMS lỗi định dạng JSON');
                return;
            }
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        }
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>